export enum CodigoACIEnum {
    PendenteAprovacao = 1,
    PendenteRecebimento = 2,
    Aprovado = 3,
    Revogado = 4,
    Concluido = 5,
    EmAprovacao = 99
}

export namespace CodigoACIEnum { }
